export default __webpack_public_path__ + "static/L4L-6068e37d9bc89bbb32674855be31801f.svg";